import React from 'react';
import { Button } from '@clearcover/atlas';
import { Can } from '../../../Shared/utils/auth';
import styles from './styles.module.css';
import { createQuotes } from '../../../Admin/authPolicies';
import { useAuth0 } from '../../../Auth';
import { Loading } from '../../../Shared/components/Loading/Loading';

type Props = {
  onCreateNewQuoteClick: () => void;
  isLoading: Boolean;
};

export const NotFound: React.FC<Props> = ({
  onCreateNewQuoteClick,
  isLoading,
}) => {
  const { user } = useAuth0();
  if (isLoading) {
    return (
      <div className={styles.main}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <div className={styles.notFound}>
          <div>There are no quotes that you can view.</div>
          <Can
            grants={user!.effectiveGrants}
            policy={createQuotes}
            yes={() => (
              <div data-testid="create-quote-link">
                You can{' '}
                <Button
                  link
                  size="sm"
                  className={styles.createQuote}
                  isSubmitting={false}
                  onClick={onCreateNewQuoteClick}
                  data-testid="create-quote"
                >
                  create a new quote
                </Button>
                .
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
};
